/* tslint:disable */

declare var Object: any;
export interface SfBusinesstripdeclarationInterface {
  "id"?: number;
}

export class SfBusinesstripdeclaration implements SfBusinesstripdeclarationInterface {
  "id": number;
  constructor(data?: SfBusinesstripdeclarationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfBusinesstripdeclaration`.
   */
  public static getModelName() {
    return "SfBusinesstripdeclaration";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfBusinesstripdeclaration for dynamic purposes.
  **/
  public static factory(data: SfBusinesstripdeclarationInterface): SfBusinesstripdeclaration{
    return new SfBusinesstripdeclaration(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfBusinesstripdeclaration',
      plural: 'SfBusinesstripdeclarations',
      path: 'SfBusinesstripdeclarations',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfBusinesstripdeclaration.ts